<template>
  <v-btn
    :to="to"
    :ripple="{ class: 'primary--text' }"
    text
    small
    color="primary"
    class="mobile-display-none "
  >
    <v-icon left>{{icon}}</v-icon>
    {{label}}
    <v-badge v-if="badge_value.toString().length > 0 && badge_value.toString() != '0' && to == '/promotions'" color="error" :content="badge_vlue" small></v-badge>
  </v-btn>
</template>

<script>
export default {
  name: "NavbarMenuItem",
  props: {
    to: {
      type: String,
      default: "/",
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    badge_value: {
      type: [String,Number],
      default: "",
    },
  },

};
</script>